<template>
  <div class="d-flex flex-row">
    <custom-avatar :image="image" />
    <div class="ml-2">
      <ion-text color="text-medium">{{ name }}</ion-text>
      <div class="d-flex mt-1">
        <ion-icon :icon="homeOutline" color="text-medium" />
        <ion-text class="ml-1" color="text-medium">{{ address }}</ion-text>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import CustomAvatar from '@/components/avatar/Avatar.vue';
import { homeOutline } from 'ionicons/icons';
export default defineComponent({
  components: {
    CustomAvatar
  },
  props: {
    image: {
      type: String
    },
    name: {
      type: String,
      default: 'no name'
    },
    address: {
      type: String,
      default: 'no address'
    }
  },
  setup() {
    return { homeOutline };
  }
});
</script>
<style lang="scss" scoped></style>
